module.exports = __webpack_public_path__ + "static/media/upload.dbad054b.svg";